import { useFormik } from 'formik'
import * as Yup from 'yup'
import { emptyUfinetSelectOption, IUfinetSelectOption, UfinetActionButton, UfinetActionButtonHandle, UfinetInput, UfinetSelect } from 'ufinet-web-components'
import { Dispatch, SetStateAction, useCallback, useMemo, useRef } from 'react'
import { onFormikChanges, onFormikTextChanges } from 'ufinet-web-functions'
import { useTranslation } from 'utils/translation/Translation'
import { useIntl } from 'react-intl'
import { ErrorResponse } from 'types/typesAndValues'
import { UsePostRejectCommissionAuthorization } from 'request'
import { toast } from 'react-toastify'
import { AuthorizationPendingColDataTypes } from 'types/authorization'
import { catalogQuery } from 'request/catalogs'





interface Props {
  refetch: () => void
  hideRejectModal: () => void
  selectedValues: AuthorizationPendingColDataTypes[]
  setSelectedValues: Dispatch<SetStateAction<AuthorizationPendingColDataTypes[]>>
}

type RejectFormData = {
  reason: string
  reasonId: IUfinetSelectOption
}

export const RejectModalForm = ({ refetch, hideRejectModal, selectedValues, setSelectedValues }: Props) => {

   const {data: dataReasonsRejection } = catalogQuery.useQueryCatalogReasonRejection()


  const actionButtonRef = useRef<UfinetActionButtonHandle>(null)
  const translate = useTranslation()
  const intl = useIntl()


  const cbSuccessRejectCommission = ({ data }: any) => {
    setSelectedValues([])
    refetch()
    hideRejectModal()
  }

  const { mutate: rejectCommission, isLoading: isLoadingRejectCommission, isError, error: errorMessage } = UsePostRejectCommissionAuthorization(cbSuccessRejectCommission)


  const showToastErrMessage = () => {
    if (typeof errorMessage === 'object' && errorMessage !== null && 'errorCode' in errorMessage) {
      const errorResponse = errorMessage as ErrorResponse;
      toast.error(`${translate("ERROR.MESSAGE")} ${errorResponse.errorCode}`, { toastId: 'Error5' });
      hideRejectModal()
    }
  }


  const dataFormSchema = Yup.object().shape({
    reasonId: Yup.object().shape({ label: Yup.string().required(intl.formatMessage({ id: 'ERROR.REQUIRED' })) }),
  })



  const sendData = (values: RejectFormData) => {
    actionButtonRef.current?.changeActionStatus(true)

    const newArray = selectedValues.map((item: any) => ({
      id: item.id,
      state: 'rejected',
      reason: values.reason,
      reasonId: values.reasonId.value,
    }))
    rejectCommission(newArray)
  }


  const onTextChange = useCallback(onFormikTextChanges, [])
  const onChange = useCallback(onFormikChanges, [])


  const initialValues: RejectFormData = useMemo<RejectFormData>(
    () => ({
      reason: '',
      reasonId: emptyUfinetSelectOption,
    }),
    []
  )



  const formik = useFormik<RejectFormData>({
    initialValues,
    validationSchema: dataFormSchema,
    onSubmit: sendData,
    validateOnChange: false,
    validateOnBlur: false,
  })





  return (
    <>
      {isError && showToastErrMessage()}
      <form onSubmit={formik.handleSubmit}>
        <div className='row'>
          <div className='row'>

            <UfinetSelect
              requiredIcon
              error={formik.errors.reasonId?.label}
              labelTitle={translate('ADD.REASON.REJECTION')}
              className="col-6"
              onChange={onChange(formik, 'reasonId')}
              value={formik.values.reasonId}
              placeholder={translate('ADD.REASON.REJECTION')}
              options={dataReasonsRejection ?? []}
            />

            <UfinetInput
              error={formik.errors.reason}
              type="text"
              labelTitle={translate('COL.COMMISSION.REASON.DETAIL.OPTIONAL')}
              className="col-6"
              onChange={onTextChange(formik, 'reason')}
              value={formik.values.reason}
              solid={false}
            />


            <UfinetActionButton
              isDisabled={isLoadingRejectCommission || !formik.values.reasonId.label}
              ref={actionButtonRef}
              className='mt-5'
              content={translate('BUTTON.REJECTED')}
            />
          </div>
        </div>
      </form>
    </>
  )
}
